import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { Faq } from './Faq';
export function Tools({ name_tool }) {
  const responsive = {
    1200: {
      items: 3,
    },
    800: {
      items: 3,
    },
    500: {
      items: 2,
    },
    0: {
      items: 1,
    },
  };

  const items = [
    <div className=" carrossel-item p-4  item-tools" data-value="1">
      <h3 className="text-color-black">1.Baixar reels instagram</h3>
      <p>
        Baixar Reels Instagram é a ferramenta essencialmente criada para o
        download de vídeos no formato de Reels. Então, se você quer guardar
        aquele vídeo engraçado que viu para mostrar para seus amigos(a) mais
        tarde, por exemplo, essa solução é indispensável.
      </p>
    </div>,
    <div className=" p-4  item-tools" data-value="2">
      <h3>2.Baixar story instagram</h3>
      <p>
        Baixar Story Instagram, por sua vez, é a ferramenta dedicada unicamente
        para o download de Stories. Seja em vídeo, imagem ou texto. Atualmente,
        é comum encontrar conteúdos valiosos nesta funcionalidade da rede
        social. Assim, você pode guardá-los em seu dispositivo facilmente com
        essa ferramenta.
      </p>
    </div>,
    <div className=" p-4  item-tools" data-value="3">
      <h3>3.Baixar foto instagram</h3>
      <p>
        Agora, se você precisa guardar fotos da rede social em seu dispositivo,
        seja para repostá-las ou montar um banco de dados para se inspirar, a
        ferramenta Baixar Foto Instagram é o que você precisa.
      </p>
    </div>,
    <div className="item p-4  item-tools" data-value="4">
      <h3>4.Baixar perfil instagram</h3>
      <p>
        Baixar Reels Instagram é a ferramenta essencialmente criada para o
        download de vídeos no formato de Reels. Então, se você quer guardar
        aquele vídeo engraçado que viu para mostrar para seus amigos(a) mais
        tarde, por exemplo, essa solução é indispensável.
      </p>
    </div>,
  ];
  return (
    <>
      <div class="cta-section footer-cta py-24 bg-pattern pattern-3 ">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-9 col-lg-10 col-xl-10">
              <div class="text-center dark-mode-texts">
                <h2 class="gr-text-2 mb-12">
                  4 NOVAS FERRAMENTAS QUE VOCÊ PRECISA CONHECER
                </h2>{' '}
                <p class="text-white mb-0 mt-6">
                  Como se não bastasse a ferramenta de baixar {name_tool}{' '}
                  Instagram, existem outras 4 novas soluções criadas pelo
                  ImpulsioneGram para ajudá-lo a ter mais possibilidades com seu
                  perfil na rede social. Confira!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <AliceCarousel
          // disableButtonsControls={true}
          disableDotsControls={true}
          mouseTracking
          items={items}
          responsive={responsive}
          controlsStrategy="alternate"
        />
      </div>
    </>
  );
}
